import React, { Fragment, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const propTypes = {

	/**
	 * The react-table row object.
	 */
	row: PropTypes.shape({

		/**
		 * The original data for the row.
		 */
		original: PropTypes.shape({}).isRequired,

		/**
		 * The set of props provided by react-table.
		 */
		getRowProps: PropTypes.func.isRequired,

		/**
		 * The data for each table cell in the row.
		 */
		cells: PropTypes.arrayOf(PropTypes.shape({

			/**
			 * The table cell props provided by react-table.
			 */
			getCellProps: PropTypes.func.isRequired,

		})).isRequired,

	}).isRequired,

	/**
	 * The field to use as the key for the table.
	 */
	keyField: PropTypes.string.isRequired,

	/**
	 * Options for row expansion.
	 */
	expandRow: PropTypes.shape({

		/**
		 * Render function for component to display in expanded row.
		 */
		render: PropTypes.func.isRequired,
	}),

	/**
	 * Click handler for row.
	 */
	onRowClick: PropTypes.func,

};

/**
 * Component to display the row for the Table component.
 *
 * @param {Object} props  The component props.
 *
 * @returns {Object}  The TableRow component.
 */
const TableRow = (props) => {

	const { row, keyField, expandRow, onRowClick } = props;

	const [expanded, setExpanded] = useState(false);

	const handleOnRowClick = useCallback(() => {

		if (onRowClick) {
			onRowClick(row.original);
		}

		if (expandRow) {
			setExpanded((prev) => !prev);
		}

	}, [row, onRowClick, expandRow]);

	let className = '';

	if (onRowClick || expandRow) {
		className += 'tc-clickable-row ';
	}

	if (expandRow && expanded) {
		className += 'tc-expanded-row-parent ';
	}

	return (
		<Fragment>
			<tr
				className={className}
				onClick={handleOnRowClick}
				{...row.getRowProps()}>
				{row.cells.map((cell) => {
					return (
						<td
							key={`row-${row.original[keyField]}-column-${cell.column.id}`}
							{...cell.getCellProps([{
								title: cell.column.title && cell.column.title(row.original),
								style: cell.column.style,
							}])}>
							{cell.render('Cell')}
						</td>
					);
				})}
			</tr>
			{expanded && expandRow && expandRow.render &&
				<tr>
					<td
						className="tc-expanded-row-child"
						colSpan={row.cells.length}>
						{expandRow.render(row.original)}
					</td>
				</tr>
			}
		</Fragment>
	);

};

TableRow.propTypes = propTypes;

export default TableRow;
